import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';

import { cn } from '@/lib/utils';
import { getDashboardIssuesByAssetQueryOptions } from '@/queries/dashboard';
import { getWorkspaceRoute } from '@/utils/routes';

export const IssuesByAssets = () => {
  const { data: response, isLoading: loading } = useQuery(getDashboardIssuesByAssetQueryOptions());
  const data = response?.assets ?? [];

  return (
    <div className="flex h-full w-full flex-col gap-4">
      <div className="flex flex-col">
        <span className="text-xl leading-[30px] font-medium">Issues by Asset</span>
        <span className="text-secondary-text text-xs leading-[18px] font-normal">Assets with the most issues</span>
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto pr-2">
        {loading ? (
          <></>
        ) : (
          data.map((issue, i) => (
            <div className={cn(i !== data.length - 1 && 'border-b-[1px] border-solid border-[#E0E2E4] pb-[17px]', i > 0 && 'pt-[17px]')} key={i}>
              <div className="flex items-center justify-between gap-2">
                <Link
                  to={getWorkspaceRoute(`/assets/${issue.asset.id}`)}
                  title={issue.asset.label}
                  className="min-w-0 truncate text-sm/[21px] font-normal !text-[#2E3940]">
                  {issue.asset.label}
                </Link>
                <span className="shrink-0 text-xs/[21px] font-bold">{issue.count}</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
